import _ from 'lodash';
import { createSelector } from 'reselect';

const _scopedState = (state) => state.entities.smartUrl;

const _smartUrlsById = (state) => _scopedState(state).byId;

const smartUrls = createSelector([_smartUrlsById], (smartUrlsById) => _.values(smartUrlsById));

export default {
  smartUrls,
};
